import { Events } from '@pncl/common-models';
import * as moment from 'moment-timezone';
import { WeeklySchedule } from './weekly-schedule';

export class Program {
  _id: string;
  siteId: string;
  name: string;
  description: string;
  startDate: moment.Moment;
  endDate: moment.Moment;
  numberOfCohorts: number;
  status: Events.Programs.ProgramStatus;
  customAttributes: string[];
  weeklySchedule: WeeklySchedule;
  assignedCohorts: number;
  archived: boolean;
  programAdmin?: string;
  eventTemplate?: string;

  constructor(data: any) {
    this._id = data._id;
    this.siteId = data.siteId ?? data.site;
    this.name = data.name;
    this.description = data.description;
    this.startDate = moment.tz(data.startDate, data?.weeklySchedule?.timezone);
    this.endDate = moment.tz(data.endDate, data?.weeklySchedule?.timezone);
    this.numberOfCohorts = data.numberOfCohorts;
    this.status = data.status;
    this.customAttributes = data.customAttributes || [];
    this.weeklySchedule = new WeeklySchedule(data.weeklySchedule);
    this.assignedCohorts = data.assignedCohorts || 0;
    this.archived = data.archived || false;
    this.programAdmin = data?.programAdmin;
    this.eventTemplate = data?.eventTemplate;
  }
}

export class ProgramStats {
  scheduledDays: number;
  scheduledDosageMinutes: number;
  actualDosageMinutes: number;

  constructor(data: any) {
    this.scheduledDays = data.scheduledDays || 0;
    this.scheduledDosageMinutes = data.scheduledDosageMinutes || 0;
    this.actualDosageMinutes = data.actualDosageMinutes || 0;
  }
}
